var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8354_190083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8354_190083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30191 11.0553L11.0562 7.99943L6.30191 4.9436V11.0553ZM8.00041 14.8016C7.05696 14.8016 6.17174 14.6232 5.34474 14.2663C4.51763 13.9094 3.79819 13.4251 3.18641 12.8134C2.57474 12.2017 2.09046 11.4822 1.73358 10.6551C1.37669 9.8281 1.19824 8.94288 1.19824 7.99943C1.19824 7.05599 1.37669 6.17076 1.73358 5.34376C2.09046 4.51665 2.57474 3.79721 3.18641 3.18543C3.79819 2.57377 4.51763 2.08949 5.34474 1.7326C6.17174 1.37571 7.05696 1.19727 8.00041 1.19727C8.94385 1.19727 9.82908 1.37571 10.6561 1.7326C11.4832 2.08949 12.2026 2.57377 12.8144 3.18543C13.4261 3.79721 13.9104 4.51665 14.2672 5.34376C14.6241 6.17076 14.8026 7.05599 14.8026 7.99943C14.8026 8.94288 14.6241 9.8281 14.2672 10.6551C13.9104 11.4822 13.4261 12.2017 12.8144 12.8134C12.2026 13.4251 11.4832 13.9094 10.6561 14.2663C9.82908 14.6232 8.94385 14.8016 8.00041 14.8016Z",
    fill: "#1D5AE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.2075b6471caf0361c01c52a2e0c0a8c3.svg";
export { ForwardRef as ReactComponent };